import { Link as RouterLink } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { X, Plus } from "lucide-react"

interface NoItemsProps {
  text: string
  addText: string
  addLink: string
  showAdd: boolean
}

const NoItems = ({ text, addText, addLink, showAdd }: NoItemsProps) => (
  <div className="flex flex-col items-center justify-center gap-4 py-10 text-center">
    <X className="h-8 w-8 text-muted-foreground" />
    <p className="text-sm text-muted-foreground">{text}</p>
    {showAdd && (
      <Button variant="outline" asChild>
        <RouterLink to={addLink}>
          <Plus className="mr-2 h-4 w-4" />
          {addText}
        </RouterLink>
      </Button>
    )}
  </div>
)

export default NoItems
